import { ROUTES } from 'app/core/router/paths';

/**
 * @description 流程步驟代碼
 */
export enum ProcessStepCodesEnum {
  /** 同意相關告知事項 (Step-1) */
  Clauses = '1',
  /** 確認資料 (Step-2-1) */
  ConfirmInfo = '2-1',
  /** 確認資料 (Step-2-2) */
  ConfirmInfoOTPAuth = '2-2'
}

/**
 * @description 流程步驟文字
 */
export enum ProcessStepTextEnum {
  /** 同意相關告知事項 (Step-1) */
  Clauses = '同意相關告知事項',
  /** 確認資料 (Step-2-1) */
  ConfirmInfo = '確認資料',
  /** 確認資料 (Step-2-2) */
  ConfirmInfoOTPAuth = '確認資料'
}

/**
 * @description 流程路由對應步驟代碼
 */
export const ProcessRouteMatchesStep: Readonly<Record<string, ProcessStepCodesEnum>> = {
  /** 同意相關告知事項 (Step-1) */
  [ROUTES.MEMBER__REGISTER__PERMISSION__CLAUSES]: ProcessStepCodesEnum.Clauses,
  /** 確認資料 (Step-2-1) */
  [ROUTES.MEMBER__REGISTER__PERMISSION__CONFIRM_INFO]: ProcessStepCodesEnum.ConfirmInfo,
  /** 確認資料 (Step-2-2) */
  [ROUTES.MEMBER__REGISTER__PERMISSION__CONFIRM_INFO__OTP_AUTH]: ProcessStepCodesEnum.ConfirmInfoOTPAuth
};

/**
 * @description 流程步驟代碼對應路由
 */
export const ProcessStepMatchesRoute: Readonly<Record<ProcessStepCodesEnum, string>> = {
  /** 同意相關告知事項 (Step-1) */
  [ProcessStepCodesEnum.Clauses]: ROUTES.MEMBER__REGISTER__PERMISSION__CLAUSES,
  /** 確認資料 (Step-2-1) */
  [ProcessStepCodesEnum.ConfirmInfo]: ROUTES.MEMBER__REGISTER__PERMISSION__CONFIRM_INFO,
  /** 確認資料 (Step-2-2) */
  [ProcessStepCodesEnum.ConfirmInfoOTPAuth]: ROUTES.MEMBER__REGISTER__PERMISSION__CONFIRM_INFO__OTP_AUTH
};
